<template>
  <v-container
    fluid
    fill-height
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center 50px',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <v-layout class="d-flex flex-column" style="height: 100%">
      <v-row class="fill-height" no-gutters>
        <v-col v-if="!expiredToken" :cols="12">
          <v-row>
            <v-col cols="12" md="2">
              <v-img
                :class="{
                  'portrait-img-left': $vuetify.breakpoint.smAndUp,
                  'portrait-img-center': $vuetify.breakpoint.smAndDown,
                }"
                contain
                :src="require('@/assets/VP_sin_fondo.png')"
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-card class="pa-6" style="display: flex; flex-direction: column">
                <v-row class="d-flex justify-center" style="flex-grow: 1">
                  <v-col cols="11" class="py-0">
                    <v-row class="my-0 mx-6 d-flex justify-center">
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedMicrophone"
                          class="select-devices border-radius-16"
                          :items="audioDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select microphone *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                        />
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedSpeaker"
                          class="select-devices border-radius-16"
                          :items="outputDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select speakers *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                        />
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedCamera"
                          class="select-devices border-radius-16"
                          :items="videoDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select camera *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                          @change="handleCameraChange"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center my-0">
                  <v-col cols="11" class="pb-0 d-flex justify-center">
                    <div class="video-container-waiting-room">
                      <video
                        id="localVideo"
                        ref="localVideo"
                        class="call-player-video"
                        poster="img/no_camera_found_girado.png"
                        autoplay
                      ></video>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="10" class="pt-4 pb-0">
                    <p class="mb-0 position-title-interview-text">Position</p>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="10" class="py-0">
                    <p class="position-text">{{ interview.position.name }}</p>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="12" class="d-flex justify-center text-center pt-0">
                    <h2 class="join-interview-text">Ready to join?</h2>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-auto">
                  <v-col class="d-flex justify-center">
                    <v-btn
                      class="enter-btn"
                      :disabled="
                        !selectedCamera ||
                        !selectedMicrophone ||
                        !selectedSpeaker ||
                        interviewStatus !== 'CREATED'
                      "
                      @click="createAndEnterInterview"
                    >
                      Create and enter
                    </v-btn>

                    <v-tooltip right>
                      <template #activator="{ on }">
                        <v-btn icon class="ml-2" v-on="on">
                          <v-icon size="20" class="access-interview-info-btn"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>
                      <span
                        v-if="interviewStatus === 'ANALYSING' || interviewStatus === 'ANALYSED'"
                      >
                        There is already a window with the interview in progress.
                      </span>
                      <span v-else-if="interviewStatus === 'ONGOING'">
                        The interview is already underway.
                      </span>
                      <span v-else-if="interviewStatus === 'EXPIRED'">
                        The interview has expired.
                      </span>
                      <span
                        v-else-if="
                          selectedCamera === null ||
                          selectedMicrophone === null ||
                          selectedSpeaker === null
                        "
                      >
                        You cannot enter the interview until you select all hardware devices.
                      </span>
                      <span v-else>You can access to the interview.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import InterviewsDataService from '@/services/InterviewsDataService';
import SocketioService from '@/services/socketioService.js';
import UserMediaController from '@/services/UserMedia.js';
import UsersDataService from '@/services/UsersDataService';

export default {
  name: 'WaitingRoom',
  beforeRouteLeave(to, from, next) {
    if (this.selfUserStream) UserMediaController.stopStream(this.selfUserStream);
    this.selfUserStream = null;
    next();
  },
  data() {
    return {
      candidates: [],
      microActivated: true,
      cameraActivated: true,
      selfUserStream: null,
      videoDevices: [],
      audioDevices: [],
      outputDevices: [],
      selectedCamera: null,
      selectedMicrophone: null,
      selectedSpeaker: null,
      interview: {
        name: 'prueba',
        description: 'Prueba',
        position: { name: 'prueba' },
        competencies: [{ name: 'prueba' }],
      },
      interviewStatus: null,
      candidateId: '',
      candidateName: '',
      interviewId: '',
      interviewerUsername: '',
      interviewerId: '',
      expiredToken: false,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  created() {
    SocketioService.emisor.$on('callRoomResponse', async (data) => {
      this.$socket.callRoom = data.callId;
    });
  },
  async mounted() {
    if (this.$route.query.token === undefined) this.$router.push('/error');
    else {
      const { token } = this.$route.query;

      await InterviewsDataService.getInterviewInfo(token)
        .then(async (res) => {
          if (res.status === 200) {
            this.interview = res.data.data.interview;
            this.interviewStatus = res.data.data.status;
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data.error === 'TOKEN_EXPIRED') this.expiredToken = true;
          else this.expiredToken = false;
        });

      if (!this.expiredToken) {
        await UsersDataService.findOne(token)
          .then(async (res) => {
            if (res.status === 200) {
              this.candidateId = res.data.data.candidateId;
              this.interviewId = res.data.data.interviewId;
              this.interviewerUsername = res.data.data.interviewerUsername;
              this.interviewerId = res.data.data.interviewerId;
              this.candidateName = res.data.data.candidateName;

              if (this.candidateId !== undefined) {
                localStorage.removeItem('isCandidate');
                localStorage.removeItem('query');
                await this.getDevices();

                Vue.prototype.$socket = SocketioService.setupSocketConnection(
                  this.interviewerId,
                  null,
                  true
                );

                await InterviewsDataService.registerCall(
                  this.candidateId,
                  this.interviewId,
                  this.interviewerId
                ).then((res) => {
                  if (res.status === 200) {
                    SocketioService.createCallRoom(this.$socket, res.data.data.id);
                  }
                });
              }
            }
          })
          .catch((err) => console.error(err));

        UserMediaController.getUserMedia(
          function (stream) {
            if (!stream) {
              stream = UserMediaController.getPlaceholderStream();
            }

            if (stream !== null) {
              UserMediaController.setMediaStreamVideoEnabled(stream, this.cameraActivated);
              UserMediaController.setMediaStreamAudioEnabled(stream, this.microActivated);

              this.selfUserStream = stream;
            } else {
              console.error('Error getting user media');
              if (this.currentRouteName !== 'candidates list') this.$router.push('/candidates');
            }
          }.bind(this)
        );
      }
    }
  },
  methods: {
    async getDevices() {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

        const devices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = devices.filter((device) => device.kind === 'videoinput');
        this.audioDevices = devices.filter((device) => device.kind === 'audioinput');
        this.outputDevices = devices.filter((device) => device.kind === 'audiooutput');
      } catch (err) {
        console.error('Error al obtener dispositivos:', err);
      }
    },
    async setCameraStream(deviceId) {
      if (this.selfUserStream) {
        this.selfUserStream.getTracks().forEach((track) => track.stop());
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: deviceId ? { deviceId: { ideal: deviceId } } : true,
        });
        this.selfUserStream = stream;

        const videoElement = this.$refs.localVideo;
        videoElement.srcObject = stream;
      } catch (error) {
        console.error('Error accessing camera:', error);
      }
    },
    async handleCameraChange() {
      await this.setCameraStream(this.selectedCamera);
    },
    createAndEnterInterview() {
      this.$router.push({
        name: 'interview',
        params: {
          interview: this.interview,
          video: this.cameraActivated,
          audio: this.microActivated,
          interviewerName: 'Interviewer',
          candidateName: this.candidateName,
          isCandidate: false,
          camera: this.selectedCamera,
          microphone: this.selectedMicrophone,
          speaker: this.selectedSpeaker,
        },
      });
    },
  },
};
</script>

<style scoped>
.call-player-video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 16px !important;
  z-index: 1 !important;
}
</style>
